import { useLazyQuery } from '@apollo/client';
import { useAuth } from 'contexts/AuthContext';
import { database } from '../../firebase';
import { USER_DETAIL } from 'graph_ql/authentication/queries';
import { useEffect } from 'react';

export const UserDetailProvider = () => {
    const { currentUser } = useAuth();
    const [getUserFn] = useLazyQuery(USER_DETAIL, {
        onCompleted: () => {},
        context: {
            scope: 'private',
        },
        fetchPolicy: 'network-only',
    });
    useEffect(() => {
        if (currentUser?.uid) {
            const onValueChange = database.realtimeDatabase
                .ref('users')
                .child(currentUser?.uid)
                .child('lastUpdated')
                .on('value', async (snapshot) => {
                    console.log('users snapshot', snapshot, currentUser?.uid);
                    getUserFn();
                });
            return () => {
                database.realtimeDatabase
                    .ref('users')
                    .child(currentUser?.uid)
                    .child('lastUpdated')
                    .off('value', onValueChange);
            };
        }
    }, [currentUser?.uid, getUserFn]);
    useEffect(() => {
        getUserFn();
    }, [getUserFn]);

    return <></>;
};
